// Filtros.jsx
import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Select_simple, Input } from './ui';
import {optionsObjeto_Tramitacion_Pagos, optionsDocumentacionPresentada, optionsEtapaPago} from '../datos/options';

const Filtros = ({ filters, onFilterChange, limpiarFiltros }) => {
	return (
		<div className="mb-6 p-4 border border-gray-200 rounded-lg bg-white shadow-sm dark:bg-gray-800 dark:border-gray-700">

			<div className="flex justify-between items-center mb-4">
				<div className="flex items-center">
					<h2 className="text-lg font-semibold text-gray-800 dark:text-white">Filtros</h2>
					{/*<InfoButtonWithPopover infoText="EN DESARROLLO" />*/}
				</div>

				<Button
					onClick={limpiarFiltros}
					className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white rounded-md transition-colors"
				>
					Limpiar filtros
				</Button>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
				{/* Filtro por Objeto 
				<div>
					<label htmlFor="objeto">Objeto:</label>
					<select
						id="objeto"
						value={filters.objeto}
						onChange={(e) => onFilterChange('objeto', e.target.value)}
					>
						<option value="Todos">Todos</option>
						<option value="Rendición">Rendición</option>
						<option value="Adenda">Adenda</option>
					</select>
				</div>*/}
				<div>
					<label htmlFor="objeto" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Objeto
                    </label>
					<Select_simple
						name="objeto"
						value={filters.objeto}
						onChange={(e) => onFilterChange('objeto', e.target.value)}//{handleFilterChange}//{(e) => setFiltroExpediente(e.target.value)}
						options={optionsObjeto_Tramitacion_Pagos}
						placeholder="Todos los trámites por objeto"
					/>					
				</div>

				{/* Filtro por Documentación */}
				<div>					
					<label htmlFor="documentacion" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Documentación
                    </label>
					<Select_simple
						name="documentacion"
						value={filters.documentacion}
						onChange={(e) => onFilterChange('documentacion', e.target.value)}
						options={optionsDocumentacionPresentada}
						placeholder="Todos los trámites por documentación"
					/>
				</div>

				{/* Filtro por Etapa de Pago */}
				<div>					
					<label htmlFor="etapaPago" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Etapa de Pago
                    </label>
					<Select_simple
						name="etapaPago"
						value={filters.etapaPago}
						onChange={(e) => onFilterChange('etapaPago', e.target.value)}
						options={optionsEtapaPago}
						placeholder="Todos los trámites por etapa de pago"
					/>
				</div>
			</div>	

			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
				<div className="flex flex-col">
					<label htmlFor="fechaInicio" className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
						Fecha Inicio de Obra
					</label>
					<DatePicker
						id="fechaInicio"
						selected={filters.fechaInicio}
						onChange={(date) => onFilterChange('fechaInicio', date)}
						dateFormat="dd/MM/yyyy"
						className="w-full p-2 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
						placeholderText="Seleccionar fecha inicio de obra"
					/>
				</div>

				<div className="flex flex-col">
					<label htmlFor="fechaFin" className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
						Fecha Fin de Obra
					</label>
					<DatePicker
						id="fechaFin"
						selected={filters.fechaFin}
						onChange={(date) => onFilterChange('fechaFin', date)}
						dateFormat="dd/MM/yyyy"
						className="w-full p-2 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
						placeholderText="Seleccionar fecha fin de obra"
					/>
				</div>

				<div className="flex flex-col">
					<label htmlFor="searchQuery" className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Buscar</label>
					<Input
						type="search"
						id="searchQuery"
						placeholder="Buscar por Nombre de Obra, Expediente de Proyecto o Partido..."
						value={filters.searchQuery}
						onChange={(e) => onFilterChange('searchQuery', e.target.value)}
						className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 dark:text-gray-200 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
					/>
				</div>
			</div>
		</div>
	);
};

export default Filtros;